import { useState, useEffect, useCallback } from "react";

const useResponsiveView = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isTabletView, setIsTabletView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);

  useEffect(() => {
    const updateView = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      setIsMobileView(newWidth <= 768);
      setIsTabletView(newWidth > 768 && newWidth <= 992);
      setIsLaptopView(newWidth > 992);
    };

    updateView();
    window.addEventListener("resize", updateView);

    return () => window.removeEventListener("resize", updateView);
  }, []);

  const isGreaterThan = useCallback((value) => width > value, [width]);
  const isLessThan = useCallback((value) => width < value, [width]);
  const isBetween = useCallback(
    (min, max) => width >= min && width <= max,
    [width]
  );

  return {
    isMobileView,
    isTabletView,
    isLaptopView,
    isBetween,
    isLessThan,
    isGreaterThan,
  };
};

export default useResponsiveView;
